interface Props {
  className?: string;
}

export const Discord2Icon = ({ className }: Props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M37.8561 11.1527C35.2677 9.95323 32.511 9.06938 29.6069 8.56433C29.2492 9.19565 28.8283 10.0584 28.5547 10.7529C25.4823 10.2899 22.431 10.2899 19.4217 10.7529C19.1271 10.0584 18.7062 9.19565 18.3484 8.56433C15.4444 9.06938 12.6877 9.95323 10.0993 11.1527C4.88039 19.0231 3.47045 26.7041 4.1649 34.2589C7.63713 36.8473 10.9831 38.4045 14.287 39.4357C15.1077 38.3203 15.8232 37.1208 16.4545 35.8792C15.255 35.4373 14.1186 34.8691 13.0454 34.2168C13.34 34.0063 13.6136 33.7749 13.8872 33.5644C20.4739 36.6368 27.6077 36.6368 34.1103 33.5644C34.3839 33.7959 34.6574 34.0063 34.952 34.2168C33.8788 34.8691 32.7214 35.4163 31.5429 35.8792C32.1743 37.1208 32.8897 38.3203 33.7105 39.4357C37.0143 38.4045 40.3814 36.8473 43.8326 34.2589C44.6533 25.4836 42.4226 17.8868 37.8982 11.1527H37.8561ZM17.3383 29.6292C15.3602 29.6292 13.7398 27.7984 13.7398 25.5467C13.7398 23.295 15.3181 21.4642 17.3383 21.4642C19.3586 21.4642 20.9579 23.295 20.9368 25.5467C20.9368 27.7774 19.3586 29.6292 17.3383 29.6292ZM30.617 29.6292C28.6389 29.6292 27.0185 27.7984 27.0185 25.5467C27.0185 23.295 28.5968 21.4642 30.617 21.4642C32.6372 21.4642 34.2366 23.295 34.2155 25.5467C34.2155 27.7774 32.6372 29.6292 30.617 29.6292Z"
      fill="currentColor"
    />
  </svg>
);
